import React, { useState } from "react";
import { Toast } from "react-bootstrap";

function ToastMessage({ message, type, show, setShow }) {
  let color = {
    success: "green",
    failure: "red",
    warning: "yellow",
  };
  return message ? (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: "fixed",
        minHeight: "100px",
        top: 0,
        right: 0,
        marginTop: "110px",
        zIndex: 999999,
        marginRight: "25px",
      }}
    >
      <Toast
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "300px",
        }}
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        autohide
      >
        <Toast.Body
          style={{
            backgroundColor: type ? color[type] : "green",
            color: "white",
            fontSize: "15px",
            textAlign: "center",
          }}
        >
          {message}
        </Toast.Body>
      </Toast>
    </div>
  ) : null;
}

export default ToastMessage;
